import "./../../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
class InstructionShiftbookDialog {
    constructor(tabPage, instructionType: string) {
        this.TabPage = tabPage;
        this.instructionType = instructionType;
    }
    instructionType = "Instruction";
    TabPage = null;
    Dialog = null;
    Bao = Bao;
    SelectedItem = ko.observable();
    DialogResult = ko.observable();
    Items = ko.observableArray();
    Deferred = $.Deferred();
    SelectItem(item) {
        this.Deferred.resolve(item);
        if (this.Dialog != null && this.Dialog.Close != null) {
            this.SelectedItem(item);
            this.DialogResult(true);
            this.Dialog.Close();
        }
    }
    ;
    OpenDialog() {
        this.TabPage.IsLoading(true);
        Bao.post("Dialog/GetShiftBooksForLinkedTasks", JSON.stringify({ instructionType: this.instructionType }), (result) => {
            // with model.length > 1 instead of 0, we skip the empty template. If there is NO empty template, users will have to have at least 2 templates for this screen to show up!
            if (result.TaskBooksForCurrentUser != null && result.TaskBooksForCurrentUser.length > 1) {
                this.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
                this.Items(result.TaskBooksForCurrentUser);
                this.Dialog.ViewModel(this);
                this.Dialog.Width(600);
                this.Dialog.Buttons([
                    {
                        Title: Bao.Session.GetMessage("msgOk"),
                        Click: () => {
                            this.Deferred.resolve(this.SelectedItem());
                            this.DialogResult(true);
                            this.Dialog.Close();
                        },
                        Enabled: ko.observable(true)
                    },
                    {
                        Title: Bao.Session.GetMessage("msgCancel"),
                        Click: () => {
                            this.Deferred.resolve();
                            this.DialogResult(false);
                            this.Dialog.Close();
                        },
                        Enabled: ko.observable(true)
                    }
                ]);
                this.Dialog.Closed = () => {
                    this.Deferred.resolve();
                };
                this.Dialog.Template(result.Message);
                this.Dialog.Open();
                this.TabPage.IsLoading(false);
            }
            else if (result.TaskBooksForCurrentUser != null && result.TaskBooksForCurrentUser.length == 1) {
                this.TabPage.IsLoading(false);
                this.SelectedItem(result.TaskBooksForCurrentUser[0]);
                this.DialogResult(true);
                this.Deferred.resolve(this.SelectedItem());
            }
            else {
                this.TabPage.IsLoading(false);
                this.DialogResult(false);
                switch (this.instructionType) {
                    case "Instruction": {
                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgUserHasNoAssignedInstructionBooks"), "info");
                        break;
                    }
                    case "Task": {
                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgUserHasNoAssignedTaskBooks"), "info");
                        break;
                    }
                    case "Briefing": {
                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgUserHasNoAssignedBriefingBooks"), "info");
                        break;
                    }
                    default: {
                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("BAO_ErrorUnexpectedError"), "info");
                        break;
                    }
                }
                this.Deferred.resolve();
            }
        });
        return this.Deferred.promise();
    }
    ;
}
export default InstructionShiftbookDialog;